import { ExternalLinkIcon } from '@assets/icons';
import { Button } from '@components/button';
import { useContactUsModal } from '@components/modal';
import { Typography } from '@components/typography';
import { useStripeCustomerPortal } from '@hooks/UseStripeCustomerPortal';
import posthog from 'posthog-js';
import { ExpiredModalWrapper } from './ExpiredModalWrapper';
import { ProgressCircle } from './ProgressCircle';

type ExpiredModalProps = {
  organizationId: string;
  name?: string;
  serviceOnly?: boolean;
};

export const ExpiredModal = ({ organizationId, name, serviceOnly = false }: ExpiredModalProps) => {
  const { openStripeCustomerPortal } = useStripeCustomerPortal({ organizationId });
  const { showModal: openContactUsModal } = useContactUsModal({
    componentProps: {
      defaultSubject: `Plan information for ${name} (${organizationId})`,
    },
  });

  const handleContactUsButton = () => {
    posthog.capture('user_contact-us_intent', {
      location: 'organizations-plan-information',
    });
    openContactUsModal();
  };

  return (
    <ExpiredModalWrapper>
      <Typography variant="subtitle1">
        {serviceOnly ? 'Your organization has expired' : 'Your subscription has expired'}
      </Typography>
      <ProgressCircle content="Expired" value={100} error />
      <Typography variant="body2" textAlign="center">
        {serviceOnly
          ? 'Confirm you have a payment method set up and any overdue invoices are paid. Please contact us if you have any questions.'
          : 'Please contact us to continue using our platform.'}
      </Typography>

      {serviceOnly && (
        <Button fullWidth onClick={openStripeCustomerPortal} startIcon={ExternalLinkIcon}>
          Manage account
        </Button>
      )}
      <Button fullWidth onClick={handleContactUsButton}>
        Contact us
      </Button>
    </ExpiredModalWrapper>
  );
};
